<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"/>
    <div class="inner">
      <h1 id="vodPackagesH1" v-translate>Balíčky videí</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <div class="field_right">
          <select-box
              id="vodprovider"
              :options="vodProviderOptions"
              v-model="formFields.id_vod_provider"
              ref="ivodproviderref"
          >
            <translate class="translate">Poskytovatel videa</translate>
          </select-box>
        </div>
        <div class="field_left">
          <date-picker
              id="provided_from"
              attrKey="provided_from"
              date-format="d. m. yy"
              v-model="formFields.provided_from"
              @update-date="updateFormDate"
          >
            <translate class="translate">Poskytováno od</translate>
          </date-picker>
        </div>
        <div class="field_right">
          <date-picker
              id="provided_to"
              attrKey="provided_to"
              date-format="d. m. yy"
              v-model="formFields.provided_to"
              @update-date="updateFormDate"
          >
            <translate class="translate">Poskytováno do</translate>
          </date-picker>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
           :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="vod-packages-list">
          <table class="vypis vypis_detail">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"/>
              <th class="no_padding checkbox"/>
              <sorting-table-title
                  v-for="title in tableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"/>
            </tr>
            </thead>

            <vod-packages-row
                v-for="entity in entities"
                :entity="entity"
                :key="entity.id"
                @input="select"
                :selectedEntities="selectedEntities"
                :ref="'vod-packages-row-ref-'+entity.id"
            ></vod-packages-row>

            <tr v-if="entities.length === 0">
              <td colspan="6">{{ $gettext('Nebyly nalezeny žádné balíčky videí.') }}</td>
            </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="vod-packages-list"
          @run-multiple-action="runMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          @select-all="toggleSelectAll"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import VodPackagesRow from "./VodPackagesRow.vue";
import listActions from "@/components/mixins/list-actions"
import {prependOptions} from "../../../utils/helpers";

export default {
  name: "VodPackages",
  components: {
    VodPackagesRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'vodPackages',
      dateFields: ['provided_from', 'provided_to'],
      entitiesKey: 'vodPackages',
      formFields: {
        id_vod_provider: 0,
        provided_from: null,
        provided_to: null,
        sort: {
          column: 'sName',
          direction: 'desc',
        },
      },
      vodProviderList: [],
    }
  },
  created(VodPackageService, VodProviderService) {
    this.entityService = VodPackageService;
    this.vodProviderService = VodProviderService;

    this.createdInit();
    this.getVodProviderList();
  },
  computed: {
    vodProviderOptions(){
      if(this.vodProviderList){
        return prependOptions([...this.vodProviderList], this.$gettext('Všechny'));
      }else{
        return [];
      }
    },
    tableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Poskytovatel videa'), column: 'sVodProviderName'},
        {key: 3, name: this.$gettext('Počet videí'), column: 'sVideosCount'},
        {key: 4, name: this.$gettext('Maximální počet videí'), column: 'sMaximumNumberOfVideos'},
        {key: 5, name: this.$gettext('Poskytováno od'), column: 'sProvidedFrom'},
        {key: 6, name: this.$gettext('Poskytováno do'), column: 'sProvidedTo'},
        {key: 7, name: this.$gettext('Počet služeb'), column: 'sServicesCount'},
      ];
    },
    csvHeaders() {
      return this.getCsvHeaderFromSortingTableTitle(this.tableTitles)
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
  },
  methods: {
    getVodProviderList() {
      this.vodProviderService.getSimpleList({id_operator: this.$_loggedUser_selectedOperatorId})
          .then((data) => {
            this.vodProviderList = data['vodProviders'];
          });
    },
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.loadDefaultByKey('id_vod_provider')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('provided_from')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('provided_to')) {
        anyChanges = true
      }
      return anyChanges;
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
      this.setUserSetting('id_vod_provider', this.formFields.id_vod_provider);
      this.setUserSetting('provided_from', this.formFields.provided_from);
      this.setUserSetting('provided_to', this.formFields.provided_to);
    },
    updateFormDate(dateInfo) {
      this.formFields[dateInfo.attrKey] = dateInfo.date
    }
  },
  watch: {
    $_loggedUser_selectedOperatorId() {
      this.formFields.id_vod_provider = 0;
      this.setUserSetting('id_vod_provider', this.formFields.id_vod_provider);
      this.getVodProviderOptions();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodPackages/VodPackagesList.vue